import styled from 'styled-components';
import SelectOption from 'styles/blocks/selectOption';

export const PainCard = styled(SelectOption)`
  flex-direction: column;
  text-align: left;
  border: 4px solid ${props => (props.selected ? props.theme.brandingSecondaryShadeTwo : 'white')};
  padding: 20px;
  border-radius: 30px;
  height: 350px;
  line-height: 1.2;
  font-size: ${props => props.theme.fontSizeSmall};
  width: 18%;
  font-family: ${props => props.theme.fontFamilyLight};
  svg {
    margin: 0 auto 30px;
    height: 100px;
    width: 100px;
  }
`;
